module.exports = __webpack_public_path__ + "img/return_btn.57ab9c00.png";